module.exports = __webpack_public_path__ + "static/media/screenshot_conversation_thorsten_adi_compr.255f186f.jpg";